import { colorPickerConfiguration } from './ColorPicker/configurations/ColorPicker.configuration.js';
import { toastConfiguration } from './Toast/configurations/Toast.configuration.js';
import { toasterConfiguration } from './Toaster/configurations/Toaster.configuration.js';
import { IPortalConfiguration } from './IPortalConfiguration.js';
/* [Component: import] */
/* [ChartComponent: import] */

export const portalConfiguration: IPortalConfiguration = {
	toast: toastConfiguration,
	toaster: toasterConfiguration,
	colorPicker: colorPickerConfiguration,
	/* [Component: interface] */
	/* [ChartComponent: interface] */
};
